import { useFlags } from 'launchdarkly-react-client-sdk';
import { LD_WORKFLOWS_SKIP_CHECKLIST_SECTIONS } from 'constants/featureFlags';

const useTaskListCounts = ({ taskList }) => {
  const flags = useFlags();
  const skipSectionsEnabled = flags[LD_WORKFLOWS_SKIP_CHECKLIST_SECTIONS];

  const _tasksCompletedCount = taskList.tasksCompletedCount;
  const _tasksSkippedCount = taskList.tasksSkippedCount;
  const _tasksTotalCount = skipSectionsEnabled
    ? taskList.tasksCount - _tasksSkippedCount
    : taskList.tasksCount;

  return {
    tasksCompletedCount: _tasksCompletedCount,
    tasksTotalCount: _tasksTotalCount,
    tasksSkippedCount: _tasksSkippedCount,
    percentageCompleted: (_tasksCompletedCount / _tasksTotalCount) * 100 || 0,
  };
};

export default useTaskListCounts;
